module.exports = __webpack_public_path__ + "img/JobSubmissionW4ExtraWithholdingsTooltip.d4127ca8.png";